module.exports = __webpack_public_path__ + "static/img/WarmPlate (14).0e520daf.png";